import React, { useContext, useRef } from "react";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";
import STcontext from "../context/STcontext";
import axios from "../context/axios";

export default function DetailsTaskST({ taskSTToUpdate }) {
   const { getTaskInfo, NewTask } = useContext(STcontext);

   const [show, setShow] = useState(false);
   const handleClose = () => setShow(false);
   const navTo = useNavigate();
   const values = [true];

   const [TaskToUpdateFromST, setTaskToUpdateFromST] = useState({
      images: [],
   });
   const [newDataTask, setNewDataTask] = useState([]);
   const [fullscreen, setFullscreen] = useState(true);
   const [images, setImages] = useState({
      imageUrl: "",
      id: 0,
   });
   function handleShow(breakpoint) {
      setFullscreen(breakpoint);
      setShow(true);
      setTaskToUpdateFromST(taskSTToUpdate);
   }

   const handelUpdateTaskFromST = (e) => {
      const { name, value } = e.target;
      setTaskToUpdateFromST({ ...TaskToUpdateFromST, [name]: value });
      setNewDataTask({ ...newDataTask, [name]: value });
   };

   const updateTaskSubmit = async (e, id) => {
      e.preventDefault();
      try {
         const updateTaskSubmit = await axios.put(
            `api/supportTechnique/updateTask/${id}`,
            newDataTask
         );
         if (updateTaskSubmit) {
            handleClose();
         } else {
            console.log("error");
         }
      } catch (err) {
         console.log("error updating");
      }
   };
   const showImage = (imageUrl, id) => {
      setImages({ imageUrl, id });
   };

   const closeImageShow = () => {
      setImages({ imageUrl: "", id: 0 });
   };

   const [retation, setRetation] = useState(0);
   const getImage = useRef();

   const retateImage = () => {
      setRetation(retation + 90);
   };

   return (
      <div>
         <Button variant="primary" onClick={() => handleShow(values)}>
            Plus Détails
         </Button>

         <Modal show={show} size="lg" onHide={() => setShow(false)}>
            {images.imageUrl ? (
               <div className="show-image">
                  <div className="close-retation-buttons">
                     <div
                        className="close-retation-button-show-image"
                        aria-label="Close"
                        onClick={retateImage}
                     >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                           <path d="M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z" />
                        </svg>
                     </div>
                     <div
                        className="close-retation-button-show-image"
                        aria-label="Close"
                        onClick={closeImageShow}
                     >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 98 98">
                           <path d="M78.2 23.3L75 20.1 48.7 46.4 22.5 20.1l-3.3 3.2 26.3 26.3-27.2 27.2 3.2 3.3 27.2-27.3L76 80.1l3.2-3.3L52 49.6l26.2-26.3z"></path>
                        </svg>
                     </div>
                  </div>

                  <div
                     style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                     }}
                  >
                     {" "}
                     <img
                        ref={getImage}
                        style={{
                           maxWidth: "50%",
                           width: "auto",
                           transform: `rotate(${retation}deg)`,
                        }}
                        className="d-block"
                        src={`${axios.defaults.baseURL}/images/` + images.imageUrl}
                        alt="..."
                     />
                  </div>
                  <div></div>
               </div>
            ) : (
               ""
            )}
            <Modal.Header closeButton>
               <Modal.Title>Détails tâche</Modal.Title>
            </Modal.Header>
            <Modal.Body
               style={{ gap: "20px", marginBottom: "10px", overflowY: "scroll" }}
            >
               <Form
                  style={{ height: '100%' }}
                  noValidate
                  method="POST"
                  onSubmit={(e) => updateTaskSubmit(e, TaskToUpdateFromST.tache_id)}
               >
                  <Row className="mb-5">
                     <Form.Group as={Col} md="6" controlId="validationCustom01">
                        <Form.Label>Nom client: </Form.Label>
                        <Form.Control
                           required
                           list="listClient"
                           type="text"
                           name="client_name"
                           autoComplete="off"
                           onChange={handelUpdateTaskFromST}
                           value={TaskToUpdateFromST.client_name}
                        />
                        <datalist id="listClient">
                           {NewTask.Clients.map((client) => (
                              <option key={client.id}>{client.nomComplet}</option>
                           ))}
                        </datalist>
                     </Form.Group>
                     <Form.Group as={Col} md="6" controlId="validationCustom02">
                        <Form.Label>Type du tâche : </Form.Label>
                        <Form.Control
                           list="typeTasks"
                           type="text"
                           name="catache"
                           autoComplete="off"
                           onChange={handelUpdateTaskFromST}
                           value={TaskToUpdateFromST.catache}
                        />
                        <datalist id="typeTasks">
                           {NewTask.TypesTasks.map((typeTask) => (
                              <option key={typeTask.id}>{typeTask.catache}</option>
                           ))}
                        </datalist>
                     </Form.Group>
                  </Row>
                  <Row className="mb-5">
                     <Form.Group as={Col} md="6" controlId="validationCustom02">
                        <Form.Label>Date previsionnel debut : </Form.Label>
                        <Form.Control
                           type="datetime-local"
                           name="date_previsionnelle_debut"
                           onChange={handelUpdateTaskFromST}
                           value={TaskToUpdateFromST.date_previsionnelle_debut}
                        />
                     </Form.Group>
                     <Form.Group as={Col} md="6" controlId="validationCustom02">
                        <Form.Label>Date fin realisation : </Form.Label>
                        <Form.Control
                           type="datetime-local"
                           name="date_fin_realisation"
                           onChange={handelUpdateTaskFromST}
                           value={TaskToUpdateFromST.date_fin_realisation}
                        />
                     </Form.Group>

                  </Row>
                  <Row className="mb-5">
                     <Form.Group as={Col} md="6" controlId="validationCustom01">
                        <Form.Label>Exécutée par : </Form.Label>
                        <Form.Control
                           required
                           type="text"
                           name="user_name"
                           onChange={handelUpdateTaskFromST}
                           value={TaskToUpdateFromST.user_name}
                        />
                     </Form.Group>
                  </Row>
                  <Row className="mb-5">
                     <Form.Group as={Col} md="12" controlId="validationCustom01">
                        <Form.Label>Observation : </Form.Label>
                        <Form.Control
                           as="textarea"
                           rows={3}
                           type="text"
                           name="observation"
                           onChange={handelUpdateTaskFromST}
                           value={TaskToUpdateFromST.observation}
                        />
                     </Form.Group>
                  </Row>
                  <Row className="mb-3 imageSlider" md="2">
                     {TaskToUpdateFromST.images.length > 0
                        ? TaskToUpdateFromST.images.map((imagesTask) => (
                           <div
                              className="images"
                              style={{ maxWidth: "15%" }}
                              key={imagesTask.id}
                           >
                              <img
                                 className="w-100 d-block"
                                 // itemId={imagesTask.id}
                                 src={
                                    `${axios.defaults.baseURL}/images/` +
                                    imagesTask.url_imgtache
                                 }
                                 alt="..."
                                 onClick={() =>
                                    showImage(imagesTask.url_imgtache, imagesTask.id)
                                 }
                                 style={{ aspectRatio: "3/3" }}
                              />
                           </div>
                        ))
                        : "images non disponible"}
                  </Row>
                  <Row className="mb-5 mt-5" style={{ height: '100%' }}>
                     <Col className="d-flex align-items-center justify-content-center">
                        <Button type="submit" variant="primary">
                           Enregistrer les modifications
                        </Button>
                     </Col>
                  </Row>
               </Form>
            </Modal.Body>
         </Modal>
      </div>
   );
}
